const text = {
  active: {
    title: 'The Arena is Open!',
    description:
      'The competition has already begun - be the first to join and set the pace! <1/> Early moves can bring the greatest rewards. Start completing contracts and seize the lead!',
  },
  inactive: {
    title: 'Get Ready for Battle!',
    description:
      'A new competition is about to begin - you still have time to gather resources, boost your production, and enter the Arena fully prepared.',
  },
};

const positionByRank: Record<
  number,
  'top10' | 'top20' | 'top30' | 'top40' | 'top50' | 'top75' | 'top100'
> = {
  21: 'top10',
  22: 'top20',
  23: 'top30',
  24: 'top40',
  25: 'top50',
  26: 'top75',
  27: 'top100',
};

export { positionByRank, text };
